import "./Schedule.scss";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function Schedule({ schedule }){
    const { t } = useTranslation('schedule');

    return (
        <div className="schedule">
            <p className="schedule-title">{t('schedule')}</p>
            <div className="schedule-week">
            {Object.entries(schedule).map(([key, content], index, array) => (
                <div key={key}>
                <div className="schedule-week-day">
                    <p className="schedule-week-day-name">{t(`${key}`)}</p>
                    <div className="schedule-week-day-time">
                    {Object.keys(content).length > 0 ? (
                        <>
                        <p>{schedule[key].open}</p>
                        <p>{schedule[key].close}</p>
                        </>
                    ) : (
                        <p>{t('closed')}</p>
                    )}
                    </div>  
                </div>
                {index < array.length - 1 && <hr />}
                </div>
            ))}
        </div>
    </div>
    )
}

Schedule.defaultProps = {
    schedule: {
        monday: {},
        tuesday: {},
        wednesday: {},
        thursday: {},
        friday: {},
        saturday: {},
        sunday: {},
    },
};

Schedule.propTypes = {
    schedule: PropTypes.shape({
        monday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
        tuesday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
        wednesday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
        thursday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
        friday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
        saturday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
        sunday: PropTypes.shape({
            open: PropTypes.string,
            close: PropTypes.string,
        }),
    }),
};

export default Schedule;